module.exports = __webpack_public_path__ + "static/media/menu.c0f05f8c.svg";